<template>
  <v-dialog
    v-model="dialog"
    max-width="1200"
    fullscreen
  >
    <v-card>
      <v-card-title>
        {{ orderNumber ? orderNumber + ' nolu Sipariş Detay' : 'Sipariş Numarası Tanımlı Değil' }}
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <b-table
            :items="erpOrderDetails"
            :fields="erpOrderDetailsHeaders"
            hover
            responsive
            :busy="erpOrderDetailsLoading"
            head-row-variant="info"
            table-variant="white"
            show-empty
        >
          <template #empty="scope">
            <h6 class="text-center my-5">
              {{ scope.loading ? "Lütfen Bekleyin" : errorMessageAll ? errorMessageAll : "Veri Bulunamadı" }}
            </h6>
          </template>
          <template #table-busy>
            <div class="text-center">
              <b-spinner
                  variant="primary"
                  size="lg"
                  label="Lütfen Bekleyin"
              ></b-spinner>
            </div>
          </template>
        </b-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import {mapActions,mapState} from "vuex";

export default {
  props:{
    showDialog:{
      type:Boolean,
      default:false
    },
    title:{
      type: String,
      default: ""
    },
    orderNumber:{
      type: String,
      default: null
    },
    orders: [],
    orderHeaders: []
  },
  computed:{
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("order",["erpOrderDetails","erpOrderDetailsHeaders","erpOrderDetailsLoading"])
  },
  data(){
    return {
      dialog: false
    }
    
  },
  methods: {
      ...mapActions("order",["fetchErpOrderDetails"]),
    _fetchErpOrderDetails(){
      this.fetchErpOrderDetails({
        params: {

        },
        body: {

        },
        urlSegments: [this.orderNumber]
      })
    }
  },
  watch:{
    "dialog": function (newVal){
      this.$emit("dialogChange",newVal)
      if(newVal && this.orderNumber){
        this._fetchErpOrderDetails()
      }
    },
    "showDialog": function (newVal){
      this.dialog = newVal
    }

  }
}
</script>